import service from '@/utils/server';

const modName='/bd/vehicleQueues/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const queuesTop = data => {
  return service({
    url: modName + 'queuesTop',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/vehicleQueues/api/index.js